import { createContext, useContext, type FunctionComponent } from 'react';

export interface DialogDrawerContextProps {
  dialogIsOpen: boolean;
  DialogComponent: FunctionComponent<any>;
  openDialog: () => void;
  closeDialog: () => void;
}

export const DialogDrawerContext = createContext<DialogDrawerContextProps>({
  dialogIsOpen: false,
  DialogComponent: () => null,
  openDialog: () => {},
  closeDialog: () => {},
});

export function useDialogDrawerContext() {
  return useContext(DialogDrawerContext);
}
